var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsInt, IsOptional, Max, Min, ValidateIf } from 'class-validator';
/** Inclusive lower bound for `daysBetweenStages` — at least one day apart. */
export const DAYS_BETWEEN_STAGES_MIN = 1;
/** Inclusive upper bound — a year between stages is already silly. */
export const DAYS_BETWEEN_STAGES_MAX = 365;
/** Inclusive bounds for any per-stage Mahngebühr (in cents). */
export const DUNNING_FEE_CENTS_MIN = 0;
export const DUNNING_FEE_CENTS_MAX = 100_000;
/**
 * Body for `PATCH /office-location-billing-details/:officeLocationId/mahnwesen`.
 *
 * Every field is optional and nullable — passing `null` clears the override
 * and reverts the field to the system default; omitting the field leaves it
 * unchanged. The handler applies a partial update.
 */
export class UpdateMahnwesenDto {
    daysBetweenStages;
    dunningFeePaymentReminderCents;
    dunningFeeFirstNoticeCents;
    dunningFeeFinalNoticeCents;
}
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(DAYS_BETWEEN_STAGES_MIN),
    Max(DAYS_BETWEEN_STAGES_MAX),
    __metadata("design:type", Object)
], UpdateMahnwesenDto.prototype, "daysBetweenStages", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(DUNNING_FEE_CENTS_MIN),
    Max(DUNNING_FEE_CENTS_MAX),
    __metadata("design:type", Object)
], UpdateMahnwesenDto.prototype, "dunningFeePaymentReminderCents", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(DUNNING_FEE_CENTS_MIN),
    Max(DUNNING_FEE_CENTS_MAX),
    __metadata("design:type", Object)
], UpdateMahnwesenDto.prototype, "dunningFeeFirstNoticeCents", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(DUNNING_FEE_CENTS_MIN),
    Max(DUNNING_FEE_CENTS_MAX),
    __metadata("design:type", Object)
], UpdateMahnwesenDto.prototype, "dunningFeeFinalNoticeCents", void 0);
//# sourceMappingURL=update-mahnwesen.dto.js.map